import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      redirect: "/"
    },
    {
      path: "/",
      name: "PageView",
      component: resolve => require(["@/view/PageView"], resolve),
      children: [
        {
          path: "/",
          redirect: "/home"
        },
        {
          path: "/home",
          name: "home",
          component: resolve => require(["@/view/HomePage"], resolve),
          meta: {
            title: "数藏官网-海南数藏文化科技有限公司"
          }
        },
        {
          path: "/software",
          name: "software",
          component: resolve => require(["@/view/Software"], resolve),
          meta: {
            title: "产品服务"
          },
          children: [
            {
              path: "/software/mcc",
              name: "software",
              component: resolve => require(["@/view/Software"], resolve),
              meta: {
                title: "购买藏品"
              }
            },
            {
              path: "/software/sae",
              name: "software",
              component: resolve => require(["@/view/Software"], resolve),
              meta: {
                title: "藏品铸造"
              }
            },
            // {
            //   path: "/software/xll",
            //   name: "software",
            //   component: resolve => require(["@/view/Software"], resolve),
            //   meta: {
            //     title: "藏品交易"
            //   }
            // }
          ]
        },
        {
          path: "/service",
          name: "service",
          component: resolve => require(["@/view/Service"], resolve),
          meta: {
            title: "技术服务"
          }
        },
        {
          path: "/newsinformation",
          name: "newsinformation",
          component: resolve => require(["@/view/NewsInformation"], resolve),
          meta: {
            title: "新闻动态"
          }
        },
        {
          path: "/newsinformation/newsdetails",
          name: "newsDetails",
          component: resolve => require(["@/view/NewsDetails"], resolve),
          meta: {
            title: "新闻详情"
          }
        },
        {
          path: "/companyintroduction",
          name: "companyintroduction",
          component: resolve =>
            require(["@/view/CompanyIntroduction"], resolve),
          meta: {
            title: "公司介绍"
          }
        },
        {
          path: "/jobchance",
          name: "jobchance",
          component: resolve => require(["@/view/JobChance"], resolve),
          meta: {
            title: "工作机会"
          }
        },
        {
          path: "/contactus",
          name: "contactus",
          component: resolve => require(["@/view/ContactUs"], resolve),
          meta: {
            title: "关于我们- 数藏中国"
          }
        },
        {
          path: "/servicedetail",
          name: "servicedetail",
          component: resolve => require(["@/view/ServiceDetail"], resolve),
          meta: {
            title: "相关服务"
          }
        }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js